<template>
  <div class="main" v-if="progress">
    <div class="spinner">
      <v-progress-circular :size="50" color="primary" indeterminate/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueGeolocation from 'vue-browser-geolocation'

Vue.use(VueGeolocation)

export default {
  name: 'CurrentLocation',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    interval: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      timerId: null,
      location: null,
      progress: false
    }
  },
  watch: {
    active: function (newValue, oldValue) {
      if (newValue) this.startSearchGps()
      else this.stopSearchGps()
    }
  },
  created: function () {
    if (this.active) this.startSearchGps()
  },
  destroyed: function () {
    this.stopSearchGps()
  },
  methods: {
    startSearchGps: function () {
      console.log('CurrentLocation.startSearchGps()')
      this.progress = true
      this.$getLocation().then(coordinates => {
        console.log(`現在地 ${coordinates}`)
        this.progress = false
        const newLocation = [coordinates.lat, coordinates.lng]
        if (this.location == null || this.location.toString() !== newLocation.toString()) {
          this.location = [coordinates.lat, coordinates.lng]
        }
        if (this.active) {
          if (this.timerId) {
            clearTimeout(this.timerId)
          }
          this.timerId = setTimeout(() => {
            this.startSearchGps()
          }, this.interval * 1000)
        }
      })
    },
    stopSearchGps: function () {
      if (this.timerId) {
        clearTimeout(this.timerId)
        this.timerId = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    position: absolute;
    width: 100%;
    height: 100%;

    .spinner {
      position: absolute;
      right: 8px;
      bottom: 8px;
      z-index: 10;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CurrentLocation.vue